import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin referrals error:', e.response.status, e.response.data); };
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const APIAdminReferrals = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/referrals/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminReferralUpdate = async (token, id, data) => {
    try { const r = await axios.patch(`${ADMIN_API_BASE}/referrals/${id}/update/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};